module.exports = __webpack_public_path__ + "img/icon_upload.69489cb5.png";